import {createRoot} from 'react-dom/client'
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from 'react-query'
import {ReactQueryDevtools} from 'react-query/devtools'
// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/plugins.scss'
import './_metronic/assets/sass/style.react.scss'
import './_metronic/assets/css/style.css'
import 'intro.js/introjs.css'; 
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import ErrorBoundary from './app/ErrorBoundary'
/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/**
 * Inject Metronic interceptors for axios.
 *
 * @see https://github.com/axios/axios#interceptors
 */
setupAxios(axios)
setupChunkRecovery();
Chart.register(...registerables)

const queryClient = new QueryClient({
  defaultOptions: {
    mutations: {
      onError: (error) => {
        // Previne erros não capturados de mutations
        console.error('Mutation error caught by QueryClient:', error)
      },
    },
    queries: {
      onError: (error) => {
        // Previne erros não capturados de queries
        console.error('Query error caught by QueryClient:', error)
      },
    },
  },
})
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <MetronicI18nProvider>
          <AuthProvider>
            <AppRoutes />
          </AuthProvider>
        </MetronicI18nProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </ErrorBoundary>
  )
}

/**
 * Captura erros de chunk e faz uma recuperação "hard":
 * - remove caches do Cache Storage
 * - desregistra qualquer Service Worker
 * - recarrega a página
 */
function setupChunkRecovery() {
  const isChunkError = (err: unknown) => {
    const txt = String(
      // algumas libs jogam o erro em `reason`, outras em `message`
      (err as any)?.message ?? (err as any)?.reason ?? err
    );

    // sinais comuns em React + code splitting
    return (
      /ChunkLoadError/i.test(txt) ||
      /Loading chunk \d+ failed/i.test(txt) ||
      /failed to fetch dynamically imported module/i.test(txt) ||
      /import\(\) failed/i.test(txt) ||
      // quando CSS/JS recebe HTML (MIME text/html) e o navegador barra
      /MIME type.+text\/html.+not a supported stylesheet/i.test(txt)
    );
  };

  const hardReload = async () => {
    try {
      // 1) limpa caches do Cache Storage (se houver)
      if ("caches" in window) {
        const names = await caches.keys();
        await Promise.all(names.map((n) => caches.delete(n)));
      }

      // 2) desregistra qualquer Service Worker (se houver)
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
    } catch {
      // segue o baile mesmo se falhar
    } finally {
      // 3) recarrega de forma “limpa”
      // usar replace evita histórico extra e ajuda a não reaproveitar sessão do cache
      window.location.replace(window.location.href.split("#")[0]);
    }
  };

  // erros "clássicos" de runtime
  window.addEventListener("error", (e) => {
    if (isChunkError(e.error ?? e)) {
      hardReload();
    }
  });

  // rejeições não tratadas (ex: import() que falhou)
  window.addEventListener("unhandledrejection", (e) => {
    if (isChunkError(e.reason ?? e)) {
      hardReload();
    }
  });
}
